module.exports = __webpack_public_path__ + "img/lincplus_05.9822cfd2.png";